import React, { useState } from "react";

const BookDemo = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    companyName: "",
    contactPlatform: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setError(null);
  };

  const validateForm = () => {
    if (!formData.firstName.trim()) return "First name is required";
    if (!formData.lastName.trim()) return "Last name is required";
    if (!formData.email.trim()) return "Email is required";
    if (!formData.phone.trim()) return "Phone number is required";
    if (!formData.companyName.trim()) return "Company name is required";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form
    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    setLoading(true);
    setError(null);
    
    try {
      // console.log('Sending data:', formData); // Debug log

      const response = await fetch(
        "https://didrouteapi.com/api/demo-request",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      // console.log('Response status:', response.status); // Debug log
      
      const data = await response.json();
      // console.log('Response data:', data); // Debug log

      if (!response.ok) {
        throw new Error(data.error || data.message || 'Failed to submit demo request');
      }

      setSuccess(true);
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        companyName: "",
        contactPlatform: "",
      });

      alert("Demo request submitted successfully!");
    } catch (error) {
      console.error('Detailed error:', {
        message: error.message,
        stack: error.stack,
        response: error.response
      });
      
      setError(error.message || 'Failed to submit demo request. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-50 min-h-screen flex items-center justify-center p-4 sm:p-6">
      <div className="max-w-7xl w-full bg-white shadow-lg rounded-lg flex flex-col lg:flex-row overflow-hidden">
        {/* Left Section */}
        <div className="lg:w-1/2 p-6 sm:p-8 bg-gray-100">
          <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold text-gray-900 mb-4">
            Book your free DiDRoute demo
          </h2>
          <p className="text-gray-700 mb-6 text-sm sm:text-base">
            A live demo is an opportunity to consult an expert and discuss the
            benefits of DiDRoute for you and your business
          </p>
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
             
              <p className="text-gray-700 text-sm sm:text-base">
                <strong>Product tour:</strong> Our expert will guide you through
                the functionality of Dialics.
              </p>
            </div>
            <div className="flex items-center space-x-3">
              
              <p className="text-gray-700 text-sm sm:text-base">
                <strong>Tailor-made approach:</strong> Recommendations for
                starting with the product and real business examples.
              </p>
            </div>
            <div className="flex items-center space-x-3">
              
              <p className="text-gray-700 text-sm sm:text-base">
                <strong>No credit card, no engagement:</strong> Completely free,
                no obligations.
              </p>
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="lg:w-1/2 p-6 sm:p-8">
          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <div className="text-red-500 text-sm mb-4 p-3 bg-red-50 rounded-lg">
                Error: {error}
              </div>
            )}
            {success && (
              <div className="text-green-500 text-sm mb-4 p-3 bg-green-50 rounded-lg">
                Demo request submitted successfully!
              </div>
            )}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label
                  htmlFor="firstName"
                  className="block text-sm font-medium text-gray-700"
                >
                  First Name *
                </label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                  placeholder="Type First Name"
                  className="w-full px-4 py-2 border rounded-lg focus:ring-purple-500 focus:border-purple-500"
                />
              </div>
              <div>
                <label
                  htmlFor="lastName"
                  className="block text-sm font-medium text-gray-700"
                >
                  Last Name *
                </label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                  placeholder="Type Last Name"
                  className="w-full px-4 py-2 border rounded-lg focus:ring-purple-500 focus:border-purple-500"
                />
              </div>
            </div>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Email *
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="example@gmail.com"
                className="w-full px-4 py-2 border rounded-lg focus:ring-purple-500 focus:border-purple-500"
              />
            </div>
            <div>
              <label
                htmlFor="phone"
                className="block text-sm font-medium text-gray-700"
              >
                Phone Number *
              </label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                placeholder="+1"
                className="w-full px-4 py-2 border rounded-lg focus:ring-purple-500 focus:border-purple-500"
              />
            </div>
            <div>
              <label
                htmlFor="companyName"
                className="block text-sm font-medium text-gray-700"
              >
                Company Name *
              </label>
              <input
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                required
                placeholder="Type company name"
                className="w-full px-4 py-2 border rounded-lg focus:ring-purple-500 focus:border-purple-500"
              />
            </div>
            <div>
              <label
                htmlFor="contactPlatform"
                className="block text-sm font-medium text-gray-700"
              >
                Skype or Telegram
              </label>
              <input
                type="text"
                name="contactPlatform"
                value={formData.contactPlatform}
                onChange={handleChange}
                placeholder="Type your username"
                className="w-full px-4 py-2 border rounded-lg focus:ring-purple-500 focus:border-purple-500"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className={`w-full py-3 text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 rounded-lg text-lg font-semibold ${
                loading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {loading ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Submitting...
                </span>
              ) : (
                'Book a Demo'
              )}
            </button>
            <p className="text-sm text-center text-gray-500 mt-4">
              You have read and agree to our{" "}
              <a href="#" className="text-purple-600 hover:underline">
                Privacy Policy
              </a>{" "}
              and{" "}
              <a href="#" className="text-purple-600 hover:underline">
                Terms and Conditions
              </a>
              .
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BookDemo;
